module.exports={"Star Rating":"Yıldız Derecelendirme","# star(s)":"{currentRating, plural, =1{# yıldız} other{# yıldız}}"};